import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { IToken, ModuleType, TokenStatus, TokenType } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { ServiceType, TokenSearchForm, useGlobalDialogViewCallbacks } from "@framework/shared";
import { List } from "@dzambalaorg/ui-kit";

import { AdminDialogKeys } from "../../../../../shared";

const COLLECTION_TOKEN_URL = "/collection/tokens";

export const CollectionToken = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IToken>
  >(COLLECTION_TOKEN_URL, { enableInfiniteScroll: isMd }, void 0, {
    tokenStatus: [TokenStatus.MINTED],
    templateIds: [],
    contractIds: [],
  });

  const { openViewDialog } = useGlobalDialogViewCallbacks<IToken>();

  const onViewToken = (token: IToken) => () => {
    openViewDialog(AdminDialogKeys.COLLECTIONS_TOKEN_VIEW, token, {
      message: "dialogs.view",
    });
  };

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "collection", "collection.token"]} />

      <PageHeader message="pages.collection.tokens" />

      <TokenSearchForm
        initialSearchValues={{
          tokenStatus: [TokenStatus.MINTED],
          templateIds: [],
          contractIds: [],
        }}
        service={ServiceType.ADMIN}
        contractModule={[ModuleType.COLLECTION]}
        contractType={[TokenType.ERC721]}
      />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(token => (
            <StyledListItem key={token.id}>
              <List.ItemText>
                {token.template?.title} #{token.tokenId}
              </List.ItemText>
              <ListActions>
                <ListAction onClick={onViewToken(token)} message="form.tips.view" icon={Visibility} />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Grid>
  );
};
